export enum LogType {
  REQUEST = "req",
  RESPONSE = "res",
  ERROR = "err",
}
